import { getConfig } from '@/app/config'
import { Language, languages, User } from '@/features/auth'
import { Customer } from '@/features/auth/domain/customer'

import { info } from '../logger'

export class UserlaneService {
  private appId: string
  private isInitialized: boolean

  get isUserlaneActive(): boolean {
    return !!window.Userlane && this.isInitialized
  }

  constructor(appId: string) {
    this.appId = appId
    this.isInitialized = false
  }

  init(user: User, customer: Customer, loggedInAsCustomer: boolean) {
    if (!window.Userlane) return

    const { Userlane } = window

    const isProduction = window.config.APP_ENV === 'production'
    const userlaneUserId = isProduction ? user.id : `${window.config.APP_ENV}-${user.id}`

    const userData = {
      segment: customer.segment || 'default',
      opsLoggedInAsUser: loggedInAsCustomer,
    }

    info('User is authenticated, initializing Userlane')

    try {
      Userlane('identify', userlaneUserId, userData)
      Userlane('lang', user.preferredLanguage || languages[0])
      Userlane('init', this.appId)

      this.isInitialized = true
    } catch (e) {
      info('Userlane is not initialized', e)
    }
  }

  start() {
    if (!this.isUserlaneActive) return

    const { Userlane } = window

    Userlane('start', this.appId)
  }

  changeLanguage(language: Language) {
    if (!this.isUserlaneActive) return

    const { Userlane } = window

    Userlane('lang', language)
    Userlane('init', this.appId)
  }

  hide() {
    if (!this.isUserlaneActive) return

    const { Userlane } = window

    Userlane('hide')
  }
}

export const userlane = new UserlaneService(getConfig().USERLANE_ID ?? '')
